import { useEffect, useState } from 'react';

/**
 * Checks if the specified flag is set on the window object.
 *
 * @param {string} flagName - The name of the flag to check.
 * @returns {boolean} True if the flag is set, false otherwise.
 */
export const mcdsFlagCheck = (flagName: string): boolean => {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  return Boolean((window as any)[flagName]).valueOf();
};

type ColorScheme = 'light' | 'dark';

export const useColorScheme = () => {
  const getColorScheme = () => {
    const body = document.body;
    return body.getAttribute('data-colorscheme') === 'dark' ? 'dark' : 'light';
  };

  const [colorScheme, setColorScheme] = useState<ColorScheme>(getColorScheme);

  useEffect(() => {
    const body = document.body;

    const observer = new MutationObserver(() => {
      setColorScheme(getColorScheme());
    });

    observer.observe(body, {
      attributes: true,
      attributeFilter: ['data-colorscheme'],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return colorScheme;
};
